const t = "_table_a8kp3_1", _ = "_fixed_a8kp3_7", e = "_th_a8kp3_10", a = "_td_a8kp3_13", o = "_tbody_a8kp3_28", c = "_thead_a8kp3_38", s = "_tr_a8kp3_42", n = "_sorter_a8kp3_45", p = "_expander_a8kp3_46", i = "_icon_a8kp3_61", d = "_left_a8kp3_66", r = "_right_a8kp3_69", k = "_compact_a8kp3_106", l = "_isMobileDivide_a8kp3_113", b = "_isSpaceBetween_a8kp3_151", h = {
  table: t,
  fixed: _,
  th: e,
  td: a,
  tbody: o,
  thead: c,
  tr: s,
  sorter: n,
  expander: p,
  icon: i,
  left: d,
  right: r,
  compact: k,
  isMobileDivide: l,
  isSpaceBetween: b
};
export {
  k as compact,
  h as default,
  p as expander,
  _ as fixed,
  i as icon,
  l as isMobileDivide,
  b as isSpaceBetween,
  d as left,
  r as right,
  n as sorter,
  t as table,
  o as tbody,
  a as td,
  e as th,
  c as thead,
  s as tr
};
//# sourceMappingURL=table.module.less.js.map
